// extracted by mini-css-extract-plugin
module.exports = {"leftAlign":"ThComponent_leftAlign__HeyMr"};